<template>
  <div class="page">
    <div class="record-wrapper">
      <div class="header">
        <h1 class="header-icon"><img src="@/assets/images/health-record.png"></h1>
        <h1 class="header-title">Access Your Medical Records</h1>
      </div>
      <ul class="record">
        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon icon="file-alt" class="icon"/>
            <p class="record-subtitle">Medical Reports (CDA)</p>
            <!-- <p class="record-explanation">Your XML-based clinical documents. You can obtain this kind of document from your medical providers.</p> -->
            <router-link to="/cdas" class="record-link">View / Upload documents</router-link>
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon icon="file-pdf" class="icon"/>
            <p class="record-subtitle">Medical Reports (PDF)</p>
            <!-- <p class="record-explanation">Your PDF-based clinical documents. You can obtain this kind of document from your medical providers.</p> -->
            <router-link to="/pdfs" class="record-link">View / Upload documents</router-link>
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon icon="file-medical" class="icon"/>
            <p class="record-subtitle">Reports</p>
            <!-- <p class="record-explanation">How do you describe this item?</p> -->
            <router-link to="/reports" class="record-link">View reports</router-link>
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon icon="file-medical-alt" class="icon"/>
            <p class="record-subtitle">Procedures</p>
            <!-- <p class="record-explanation">How do you describe this item?</p> -->
            <router-link to="/pdfs" class="record-link">View procedures</router-link>
          </div>
        </li>

      </ul>
    </div>

  </div>
</template>

<script>
  export default {
    name: "WelcomeQuickNavRecords"
  }
</script>

<style scoped lang="scss">
  @import "../../../stylesheets/mixins/flex";

  $color-font: #58595b;
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  p {
    margin: 0;
  }
  .page {
    width: 100%;
  }
  .record-wrapper {
    max-width: 700px;
    margin: 0 auto;
    padding: 50px 30px;
    border: 1px solid lightgray;
    border-radius: 5px;
    text-align: center;
  }
  .header {
    text-align: center;
    color: $color-font;
    .header-icon img {
      width: 100px;
    }
    .header-title {
      font-size: 1.8em;
    }
  }
  .record {
    @include flex-box();
    @include flex-wrap(wrap);
  }
  .record-item {
    @include flex(1, 0, 45%);
    margin-top: 30px;
    width: 350px;
  }
  .record-title {
    padding: 0 20px;

    .record-subtitle {
      color: $color-font;
      padding: 5px 0;
      font-weight: bold;
    }
    .record-explanation {
      /*text-align: left;*/
      color: gray;
      font-size: 0.9em;
    }
    .record-link {
      display: block;
      width: 100%;
      background-color: #007bff;
      color: #fff;
      font-size: 0.8em;
      border-radius: 3px;
      padding: 5px 0;
      margin-top: 10px;
    }

  }
  .icon {
    font-size: 2.0em;
  }

  @media only screen and (max-width: 768px) {
    .page {
      padding: 0;
    }
    .record-wrapper {
      padding: 30px 10px;
    }
    .record-item {
      @include flex(1, 0, 100%);
      margin-top: 30px;
    }
    .header {
      .header-title {
        font-size: 1.2em;
        font-weight: bold;
      }
      .header-icon img {
        display: none;
      }
    }
  }

</style>